import { writable } from "svelte/store";
import { user, get__store, alert } from '../store.js';
import { Topics, TopicRequest, TopicsRequest } from "../../proto/task_pb";
import { TopicServicePromiseClient } from "../../proto/task_grpc_web_pb";

export const topics = writable([]);


export class Topicsvc {
    constructor(deps) {
        this.proto = {
            TopicsRequest,
            TopicRequest,
            Topics,
            TopicClient: TopicServicePromiseClient,
        }
        this.client = new this.proto.TopicClient(VITE_APIURL, null, null)
        this.refresh()
    }

    setJWT() {
        return {
            ["X-CSRF-Token"]: get__store(user).accessToken,//'localStorage.getItem("X-CSRF-Token")',
        };;
    }

    getTopics() {
        return topics
    }

    refresh() {
        topics.set([]);
        try {
        const req = new this.proto.TopicsRequest()
        this.client.index(req, this.setJWT()).then(res => {
            res.getTopics().getTopicList().map(topic => {
                topics.update(n => [...n, this.sveltetopicfromproto(topic)])
            })
        })
        } catch (e) {
            console.log("Error retrieving topics", e);
            alert.update((n) => [
                ...n,
                "Failed to retrieve topics " + e.message,
            ]);            
        }
        return
    }
    completed() {
        const req = new this.proto.TopicRequest()
        return this.client.topiccompleted(req, this.setJWT()).then(res => {
            return res.getTopicList()
        })
    }
    add(data) {
        let req = new this.proto.TopicRequest()
        req.setTopic(this.protobuffromsveltetopic(data))
        this.client.add(req, this.setJWT()).then(this.refresh())
        return
    }

    update(arguements) {
        arguements.forEach(item => {
          let req = new this.proto.TopicRequest()
          req.setTopic(this.protobuffromsveltetopic(item))
          this.client.update(req, this.setJWT()).catch( e => {
                console.log("Error updating topic", e);
                alert.update((n) => [
                    ...n,
                    "Failed to update topics " + e.message,
                ])
          })
        })
        this.refresh();
        return
    }

    sveltetopicfromproto(data) {
        return {
            id: data.getId(),
            name: data.getName(),
            active: data.getActive(),
            //description: data.getDescription(),
            updatedAt: data.getUpdatedAt(),
            createdAt: data.getCreatedAt(),
        }
    }
    protobuffromsveltetopic(data) {
        let tsk = new proto.proto.Topic
        tsk.setId(data.id)
        tsk.setName(data.name)
        tsk.setActive(data.active)
        //tsk.setDescription(data.description)
        //tsk.setStatus(data.status)
        //tsk.setPriority(data.priority)
        //tsk.setNextaction(data.nextaction)
        //tsk.setViewedAt(data.viewedAt)
        return tsk
    }
}
